import {
  withTranslation,
} from 'react-i18next';

import RegattaResultTableRaceFieldsView from './RegattaResultTableRaceFieldsView';

const TranslatedComponent = withTranslation()(RegattaResultTableRaceFieldsView);

const Component = TranslatedComponent;

export default Component;
